import B2BInvoiceAdminListPage from "./B2BInvoiceAdminListPage";

export default function AccountingB2BPage() {
  return (
    <B2BInvoiceAdminListPage
      title="Faktury B2B"
      defaultStatus=""
    />
  );
}
